import clsx from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

import { settingHeader, settingHeaderBeta } from './share.css';

interface SettingHeaderProps extends Omit<
  HTMLAttributes<HTMLDivElement>,
  'title'
> {
  title: ReactNode;
  subtitle?: ReactNode;
  beta?: boolean;
  action?: ReactNode;
}

export const SettingHeader = ({
  title,
  subtitle,
  beta,
  action,
  className,
  ...otherProps
}: SettingHeaderProps) => {
  return (
    <div className={clsx(settingHeader, className)} {...otherProps}>
      <div className="title">
        <span className="title-main">
          {title}
          {beta ? <span className={settingHeaderBeta}>Beta</span> : null}
        </span>
        {action ? <span className="action">{action}</span> : null}
      </div>
      {subtitle ? <div className="subtitle">{subtitle}</div> : null}
    </div>
  );
};
